<template>
	<v-btn
		block
		:disabled="disabled"
		:loading="loading"
		color="primary"
		class="mb-2"
		small
		@click="onsubmit"
	>
		Convertir a usuario <v-icon right>mdi-account-reactivate</v-icon>
	</v-btn>
</template>

<script>
import { mapActions } from 'vuex';
export default {
	name: 'UserConvertButton',
	props: {
		personId: {
			type: String,
			required: true,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	data() {
		return {
			loading: false,
		};
	},
	methods: {
		async onsubmit() {
			this.loading = true;
			await this.convertToUser(this.personId);
			this.loading = false;
		},
		...mapActions({
			convertToUser: 'Person/convertToUser',
		}),
	},
};
</script>
